import { render, staticRenderFns } from "./WoundHealingTemplate.vue?vue&type=template&id=271d1d34&scoped=true"
import script from "./WoundHealingTemplate.vue?vue&type=script&lang=js"
export * from "./WoundHealingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d1d34",
  null
  
)

export default component.exports